<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <v-server-table url="" :columns="columns" :options="options" name="collections" ref="collections"
                            @loading="toggleLoading" @loaded="toggleLoading" @row-click="showCollection">
              <template slot="sequences" slot-scope="props">
                <div>
                  {{ props.row.sequences.data.length }}
                </div>
              </template>

              <template slot="actions" slot-scope="props">
                <div>
                  <button class="btn btn-danger btn-sm" v-on:click.stop="remove(props.row.id)"  v-if="$accessControl.isOperator($store.state.profile.profile)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </template>
            </v-server-table>
          </div>
          <!-- /.box-body -->
          <div class="overlay" v-show="loading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import collectionsApi from '../../api/collections'

  export default {
    data () {
      return {
        columns: [
          'title', 'description', 'sequences', 'actions'
        ],
        options: {
          headings: {
            'title': 'Titolo',
            'description': 'Descrizione',
            'sequences': 'N sequenze'
          },
          sortable: [
            'titolo', 'descrizione'
          ],
          requestFunction: function (query) {
            return collectionsApi.index(query)
          }
        },
        loading: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Raccolte inserite',
        createButton: {
          display: true,
          text: 'Nuova raccolta',
          to: 'collection'
        }
      })
    },

    methods: {
      remove (id) {
        if (confirm('Sei sicuro di procedere?')) {
          this.loading = true
          collectionsApi.delete(id)
            .then((response) => {
              this.$refs.collections.refresh()
              toastr.success('La raccolta è stata rimossa correttamente')
              this.loading = false
            })
            .catch((response) => {
              this.loading = false
            })
        }
      },
      toggleLoading () {
        // this.loading = !this.loading
      },
      showCollection (row) {
        this.$router.push({name: 'collectionsShow', params: {id: row.row.id}})
      }
    }
  }
</script>

<style>
  tr {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/collections/CollectionsIndex.vue